import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import heroImage from "@/assets/header-webpage-cetasol.png";

import { smoothScrollToElement } from "@/lib/smoothScroll";

const HeroSection = () => {
  
  const { t } = useTranslation('home');
  return (
    <section className="relative min-h-screen flex items-center pb-16 pt-20 md:pb-24 md:pt-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="Digital twin visualization of a tugboat with real-time data overlay"
          className="w-full h-full object-cover object-[center_35%]"
          loading="eager"
        />
        <div className="absolute inset-0 bg-background/20" />
        <div className="absolute inset-0 bg-gradient-to-b from-background/70 via-transparent to-background" />
      </div>

      <div className="container relative z-10 mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: "easeOut" }}
          className="max-w-2xl"
        >
          <h1 className="font-display text-3xl sm:text-hero md:text-hero-lg text-foreground mb-4 md:mb-6">
            {t('hero.headline1')}<br />
            <span className="font-bold">{t('hero.headline2')}</span>
          </h1>
          <p className="text-base sm:text-lead text-foreground mb-8 md:mb-10 max-w-lg">
            {t('hero.description')}
          </p>
          <div className="flex flex-col sm:flex-row flex-wrap gap-3 sm:gap-4">
            <Link
              to="/solutions"
              className="inline-flex items-center justify-center gap-2 bg-primary text-primary-foreground px-6 py-3 rounded-md font-medium text-sm hover:bg-primary-hover transition-colors"
            >
              {t('hero.ctaSolutions')} <ArrowRight size={16} />
            </Link>
            <button
              onClick={() => {
                const target = document.getElementById('vessel-segments');
                if (target) {
                  smoothScrollToElement(target, 2000, "start");
                }
              }}
              className="inline-flex items-center justify-center gap-2 border border-[hsl(var(--secondary-border))] text-foreground bg-secondary/18 px-6 py-3 rounded-md font-medium text-sm hover:bg-secondary/30 transition-colors"
            >
              {t('hero.ctaSegment')}
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;
